export const navTranslations = {
    en: {
        home: "Home",
        dubrovnik: "Dubrovnik by boat",
        elaphiti: "Elaphite islands cruise",
        contact: "Contact"
    },
    hr: {
        home: "Početna",
        dubrovnik: "Dubrovnik brodom",
        elaphiti: "Krstarenje Elafitima",
        contact: "Kontakt"
    },
    es: {
        home: "Inicio",
        dubrovnik: "Dubrovnik en barco",
        elaphiti: "Crucero islas Eláfites",
        contact: "Contacto"
    },
    it: {
        home: "Home",
        dubrovnik: "Dubrovnik in barca",
        elaphiti: "Crociera isole Elafiti",
        contact: "Contatto"
    },
    pl: {
        home: "Strona główna",
        dubrovnik: "Dubrownik łodzią",
        elaphiti: "Rejs po wyspach Elafiti",
        contact: "Kontakt"
    },
    fr: {
        home: "Accueil",
        dubrovnik: "Dubrovnik en bateau",
        elaphiti: "Croisière îles Élaphites",
        contact: "Contact"
    },
    de: {
        home: "Startseite",
        dubrovnik: "Dubrovnik per Boot",
        elaphiti: "Kreuzfahrt Elaphiten-Inseln",
        contact: "Kontakt"
    }
};